import services from '@/http'
import * as storage from '../storage'
import * as types from './mutation-types'



export const ActionSetLocalGarage = ({commit},{garage}) => {
  commit(types.SET_GARAGE, garage)

}

export const ActionLoadGarage = ({commit},{id}) => {
  commit(types.SET_LOAD_GARAGE)
  return services.home.loadGarage({id}).then(res => {
    storage.setGarage(res.data.results)
    commit(types.SET_GARAGE, res.data.results)
    commit(types.SET_LOAD_GARAGE)
  })
}


export const ActionSetGarageLocalStorage = ({ commit }, payload) => {
  commit(types.SET_GARAGE, payload)
}

export const ActionSetCarSelectedLocalStorage = ({ commit }, payload) => {
  storage.setCarSelected(payload)
  sessionStorage.removeItem('product_search')
  commit(types.SET_CAR_SELECTED, payload)
}

export const ActionSetGarageSelectedLocalStorage = (context,payload) => {
  storage.setGarageSelected(payload)
}

export const ActionSetCredito = ({ commit }, payload) => {
  commit(types.SET_CREDIT, payload)
}

export const ActionSetCreditoData = ({ commit }, payload) => {
  commit(types.SET_CREDIT_DATA, payload)
}

export const ActionGetCredito = (context,payload) => {
  services.home.getCredito({'client':payload }).then(res => {
    context.commit(types.SET_CREDIT,res.data.total_credito)
    context.commit(types.SET_CREDIT_DATA,res.data.data)
  })
  .catch(err => {
    context.commit(types.SET_CREDIT,'-')
    context.commit(types.SET_CREDIT_DATA,'-')
    console.log(err.statusText)
  })
}

export const ActionGetColecoes = ({commit}) => {
  return services.home.GetColecoes().then(res => {
    commit(types.SET_COLECAO, res.data.results)
  })
  .catch(err => {
    console.log(err)
  })
}
